/**
 * @generated SignedSource<<87b2311aae9d95303878d09732272b06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AbtestScenarioPageContentTextReplaceActionKind = "TEXT_REPLACEMENT" | "DIV_ELEMENT_ADDITION" | "ATTRIBUTE_REPLACEMENT" | "%future added value";
export type AbtestScenarioPageContentTextReplaceTargetKind = "ID" | "SELECTOR" | "XPATH" | "%future added value";
export type AddAbtestScenarioPageContentTextReplaceInput = {
  clientMutationId?: string | null;
  abtestScenarioPageId: string;
  targetType?: AbtestScenarioPageContentTextReplaceTargetKind | null;
  actionType?: AbtestScenarioPageContentTextReplaceActionKind | null;
  targetValue?: string | null;
  targetAttribute?: string | null;
  replaceValue?: string | null;
};
export type ABTestPatternEditScreenContainer_AddTextReplaceContentMutation$variables = {
  input: AddAbtestScenarioPageContentTextReplaceInput;
};
export type ABTestPatternEditScreenContainer_AddTextReplaceContentMutationVariables = ABTestPatternEditScreenContainer_AddTextReplaceContentMutation$variables;
export type ABTestPatternEditScreenContainer_AddTextReplaceContentMutation$data = {
  readonly addAbtestScenarioPageTextReplace: {
    readonly abtestScenarioPageContentEdge: {
      readonly node: {
        readonly __typename: "AbtestScenarioPageContentTextReplace";
        readonly id: string;
        readonly targetType: AbtestScenarioPageContentTextReplaceTargetKind;
        readonly targetValue: string;
        readonly targetAttribute: string;
        readonly actionType: AbtestScenarioPageContentTextReplaceActionKind;
        readonly replaceValue: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    } | null;
  } | null;
};
export type ABTestPatternEditScreenContainer_AddTextReplaceContentMutationResponse = ABTestPatternEditScreenContainer_AddTextReplaceContentMutation$data;
export type ABTestPatternEditScreenContainer_AddTextReplaceContentMutation = {
  variables: ABTestPatternEditScreenContainer_AddTextReplaceContentMutationVariables;
  response: ABTestPatternEditScreenContainer_AddTextReplaceContentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetAttribute",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "replaceValue",
      "storageKey": null
    }
  ],
  "type": "AbtestScenarioPageContentTextReplace",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ABTestPatternEditScreenContainer_AddTextReplaceContentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddAbtestScenarioPageContentTextReplacePayload",
        "kind": "LinkedField",
        "name": "addAbtestScenarioPageTextReplace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AbtestScenarioPageContentEdge",
            "kind": "LinkedField",
            "name": "abtestScenarioPageContentEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ABTestPatternEditScreenContainer_AddTextReplaceContentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddAbtestScenarioPageContentTextReplacePayload",
        "kind": "LinkedField",
        "name": "addAbtestScenarioPageTextReplace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AbtestScenarioPageContentEdge",
            "kind": "LinkedField",
            "name": "abtestScenarioPageContentEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e19cc2ebf4532000bfc4a56e1ddff854",
    "id": null,
    "metadata": {},
    "name": "ABTestPatternEditScreenContainer_AddTextReplaceContentMutation",
    "operationKind": "mutation",
    "text": "mutation ABTestPatternEditScreenContainer_AddTextReplaceContentMutation(\n  $input: AddAbtestScenarioPageContentTextReplaceInput!\n) {\n  addAbtestScenarioPageTextReplace(input: $input) {\n    abtestScenarioPageContentEdge {\n      node {\n        __typename\n        ... on AbtestScenarioPageContentTextReplace {\n          id\n          targetType\n          targetValue\n          targetAttribute\n          actionType\n          replaceValue\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "609a5ba523bf17bf02da303575aa86f1";

export default node;
